export default {"src":"/_next/static/media/erp-systems.ac4d350d.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};